import React, { ComponentProps } from 'react';
import { LazyComponent } from '@fiverr-private/ui_utils';
import type { BriefFloatingFormTrigger } from '@fiverr-private/dm_brief_creation';

const lazyImport = () =>
    import(/* webpackChunkName: 'bff_floating_form_trigger' */ '@fiverr-private/dm_brief_creation').then((module) => ({
        default: module.BriefFloatingFormTrigger,
    }));

export const LazyBriefFloatingFormTrigger = (props: ComponentProps<typeof BriefFloatingFormTrigger>) => (
    <LazyComponent lazyImport={lazyImport} componentProps={props} />
);
